module.exports = __webpack_public_path__ + "img/spin_btn.b4ffb32d.png";